import moment from 'moment';
// import DataService from 'js/modules/dataservice';

const CM = {};
const internals = {
  cmCreatePageviewTag: [
    '/Step 1 Travel Information',
    '/Step 2 Acommodation',
    '/Step 3 Airfare',
    '/Step 4 Guest Info',
    '/Step 5 Payment',
    '/Step 6 Confirmation'
  ],
  roomDetails: {}
};
const currentStep = window._app.page.step;

const calculateNights = (checkInDate, checkOutDate) => {
  const ckIn = new Date(checkInDate);
  const ckOut = new Date(checkOutDate);
  const _mCkIn = moment(ckIn);
  const _mCkOut = moment(ckOut);
  const numberOfNights = _mCkOut.diff(_mCkIn, 'days');

  return numberOfNights;
};

const evenFloat = (n) => n.toFixed(2);

CM.cmCreatePageviewTag = () => {
  // console.log('cmCreatePageviewTag');

  try {
    if (window.cmCreatePageviewTag) {
      window.cmCreatePageviewTag(location.hostname + internals.cmCreatePageviewTag[currentStep - 1]);
    }
  } catch (err) {
    console.warn('cmCreatePageviewTag at cmJS catched an error.', err);
  }
};

CM.cmCreateProductviewTag = (resortName, categoryCode, name, price, checkInDate, checkOutDate) => {
  // console.log('cmCreateProductviewTag', resortName, categoryCode, name, price, checkInDate, checkOutDate);
  const numberOfNights = calculateNights(checkInDate, checkOutDate);

  try {
    if (window.cmCreateProductviewTag) {
      window.cmCreateProductviewTag(`${ resortName } : ${ categoryCode }`, `${ resortName } : ${ name }`, resortName);
      internals.roomDetails = {
        resortName, categoryCode, name, numberOfNights, price
      };
    }
  } catch (err) {
    console.warn('cmCreateProductviewTag at cmJS catched an error.', err);
  }
};

CM.cmCreateShopAction5Tag = async(rstCode, categoryCode, summary) => {
  // const { resortName, categoryCode, name, numberOfNights, price } = internals.roomDetails;
  // const parameters = {
  //   rstCode,
  //   categoryCode
  // };

  try {
    // const { status } = await DataService.getRoomDetails(parameters);

    // console.log(roomDetails);

    // if (status === 'success') {
    const { vacationData, resortInfo, roomData } = summary;
    const { checkInDate, checkOutDate } = vacationData;
    const { resortShortName } = resortInfo;
    const { roomName, PPPN } = roomData;
    const numberOfNights = calculateNights(checkInDate, checkOutDate);
    const price = PPPN || 0;

    if (window.cmCreateShopAction5Tag) {
      console.log('cmCreateShopAction5Tag', `${ resortShortName } : ${ categoryCode }`, `${ resortShortName } : ${ roomName }`, numberOfNights, evenFloat(price), resortShortName);
      window.cmCreateShopAction5Tag(`${ resortShortName } : ${ categoryCode }`, `${ resortShortName } : ${ roomName }`, numberOfNights, evenFloat(price), resortShortName);
      CM.cmDisplayShops();
    }
    // }
  } catch (err) {
    console.warn('cmCreateShopAction5Tag at cmJS catched an error.', err);
  }
};

CM.cmCreateOrderTag = (summary) => {
  const { webConfirmationNumber, bookingTotal, guestsData } = summary;
  const { city, email, state, zipCode } = guestsData;

  // console.log('cmCreateOrderTag', webConfirmationNumber, evenFloat(bookingTotal), '0.00', email, city, state.toUpperCase(), zipCode);

  try{
    if (window.cmCreateOrderTag) {
      window.cmCreateOrderTag(webConfirmationNumber, evenFloat(bookingTotal), '0.00', email, city, state.toUpperCase(), zipCode);
    }
  } catch (err) {
    console.warn('cmCreateOrderTag at cmJS catched an error.', err);
  }
};

CM.cmCreateRegistrationTag = (summary) => {
  const { guestsData } = summary;
  const { city, country, email, state, zipCode } = guestsData;

  // console.log('cmCreateRegistrationTag', email, email, city, state.toUpperCase(), zipCode, country.toUpperCase());

  try {
    if (window.cmCreateRegistrationTag) {
      window.cmCreateRegistrationTag(email, email, city, state.toUpperCase(), zipCode, country.toUpperCase());
    }
  } catch (err) {
    console.warn('cmCreateRegistrationTag at cmJS catched an error.', err);
  }
};

CM.cmCreateShopAction9Tag = (summary) => {
  const { vacationData, resortInfo, roomData, guestsData, webConfirmationNumber, bookingTotal } = summary;
  const { checkInDate, checkOutDate } = vacationData;
  const { resortShortName } = resortInfo;
  const { roomCode, roomName, PPPN } = roomData;
  const { email } = guestsData;
  const numberOfNights = calculateNights(checkInDate, checkOutDate);
  const price = PPPN || 0;

  try {
    if (window.cmCreateShopAction9Tag) {
      // console.log(`cmCreateShopAction9Tag ${ resortShortName } : ${ roomCode }`, `${ resortShortName } : ${ roomName }`, numberOfNights, evenFloat(price), email, webConfirmationNumber, evenFloat(bookingTotal), resortShortName);

      window.cmCreateShopAction9Tag(`${ resortShortName } : ${ roomCode }`, `${ resortShortName } : ${ roomName }`, numberOfNights, evenFloat(price), email, webConfirmationNumber, evenFloat(bookingTotal), resortShortName);
    }
  } catch (err) {
    console.warn(err);
  }
};

CM.cmDisplayShops = () => {
  // console.log('cmDisplayShops');

  try {
    if (window.cmDisplayShops) {
      window.cmDisplayShops();
    }
  } catch (err) {
    console.warn('cmDisplayShops at cmJS catched an error.', err);
  }
};

CM.calculateNights = calculateNights;

export default CM;



// WEBPACK FOOTER //
// ./js/modules/cm.js